/**
 * @mockdata
 * 详细 mock 语法参见 https://github.com/nuysoft/Mock/wiki/Syntax-Specification
 */
import { RateDetail } from './rate';
import { TaskList } from './cleaner';
export const MockData = {
  "@ignore /api/thirdparty/account_login": {
    error_code: 213004,
    error_msg: "爱彼迎人机交互验证",
    data: {
    //   geetest: {
    //     airlock_id: -3115774136634229,
    //     flow: "captcha_flow",
    //     recaptcha: {
    //       verify_key: "1591798273_ODA1NDg4ODgxMTI3",
    //       data: {
    //         site_key: "6Lf20R0UAAAAAJDj8fQYXmFJWTbSPtvhtjV0VFoy",
    //         android_site_key: "6LdAOmsUAAAAADtHajb3Pq1hy547UPtrEKrT6dNq",
    //       },
    //       url:
    //         "https://www.airbnb.com/airlock?al_id=-3115774136634229&key=d306zoyjsyarp7ifhu67rjxn52tv0t20&sid=1:1591798274:MTY0NmE1ZjMwY2I3NDk2M2E3NzU5ZDZhOTI0ZTY3MjcxNTg5MWE1Zg==--1646a5f30cb74963a7759d6a924e672715891a5f",
    //     },
    //   },
      //   "booking": {
      //     "call": [
      //       {
      //         "id": "c5254f356709d241c847896a3ecf6dc3",
      //         "phone": "+86*******0090"
      //       }
      //     ],
      //     "sms": [
      //       {
      //         "id": "c5254f356709d241c847896a3ecf6dc3",
      //         "phone": "+86*******0090"
      //       }
      //     ]
      //   },
        "zhenguo": {
          "question": "手机短信验证",
          "type": "sms",
          "sms": [
            {
              "id": "17dc51f5b0954c34813b5b72b9428a3a",
              "phone": "130*****765"
            }
          ]
        },
      //   "geetest": {
      //     "airlock_id": 1754,
      //     "flow": "captcha_flow",
      //     "china_captcha": {
      //         "gt": "842cc17081653d0e7cf4bde73f80e4a9",
      //         "challenge": "d77b3f95ddc0664469c05edf86716b0b"  //需要作为verify_key回传
      //     }
      // }
    },
  },
  '@ignore /api/member/detail':
  {
      "error_code": 0,
      "error_msg": "",
      "data": {
          "house_quantity": 110,
          "current": {
              "id": 1,
              "operator_id": 10265,
              "edition": 1,
              "quantity": 55,
              "period": 12,
              "start_time": "2019-11-29 16:45:42",
              "expire_time": "2024-11-07 16:45:42",
              "rest_days":0,
          },
          "status": 1,
          "next": []
      }
  },
  '@ignore /api/member/order/prepay': {
    error_code: 200
  },
  '@ignore /api/member_promotion/list': {
    "error_code": 0,
    "error_msg": "",
    "data": {
        "list|3-5": [
            {
                "code": "F90F10DEFAE64372A55451D9C149D9EF",
                "status|1": [0,3],  //状态。 0:未使用 1:已使用 2:已禁用 3:已过期； 此列表仅展示0、3状态
                "type": 1, //优惠券类型。 0:试用期延长（不在列表展示） 1:打折 2:满减 3: 代金券
                "payload": {
                    "percent": "50" //折扣百分比 例: 50%
                },
                "start_time": "2020-06-12 15:55:35",
                "end_time": "2020-06-12 15:55:35",
                "take_time": "2020-06-12 16:22:51"
            },
            {
                "code": "57ECFE2A59654DD0B4B68651B0B926F5",
                "status|1": [0,3],
                "type": 2,
                "payload": {
                    "reach": 100, //满
                    "reduce": 1,//减
                    "currency": "CNY"//币种
                },
                "start_time": "2020-06-12 15:55:35",
                "end_time": "2020-06-18 15:55:35",
                "take_time": "2020-06-12 16:22:12"
            },
            {
                "code": "B8AB0856F33549F490E86A181B1E3535",
                "status|1": [0,3],
                "type": 3,
                "payload": {
                    "currency": "CNY",//币种
                    "amount": "20"//抵扣金额
                },
                "start_time": "2020-06-12 15:55:35",
                "end_time": "2020-07-18 15:55:35",
                "take_time": "2020-06-12 16:19:42"
            }
        ],
        "total": 4
    }
  },
  '@ignore /api/member/order/payment_detail': {
    error_code: 200001
  },
  '@ignore /api/checkin_guide/info/4C82F949F747471CA68B6918540B5362': {
    "request_id": "RT1594805751103440",
    "error_code": 0,
    "error_msg": "",
    "data": {
        "guide_info": {
          "logo":"https://oss.image.xiaogetech.com/MMG1591780727486.jpg/small",
          "greet_content":"你好。欢迎关联hostex",
          "house_title":"111111111111111111111",
          "check_in":"2020-07-26",
          "check_out":"2020-07-27",
          "need_credential":1,
          "step":1,
          "address":{//模块名 为null时表示没有，就不展示了
              "address":"北京永泰庄",
              "log_address":null,
              "lat_address":32.56,
              "address_remarks":null //null表示没有
          },
          "lock":{
              "lock_password":"123456",//可能为“暂无”  "暂不可见"
              "lock_remarks":null,//null 表示没有
          },  //模块名 为null时表示没有，就不展示了
          "wifi":{
              "wifi_name":"xiaoge",
              "wifi_password":"wwpg",
              "wifi_remarks":null //null表示没有
          },
          "detail_guide":{
              "detail_guide_url":"https://www.myhostex.com",
              "detail_guide_remarks":null //null表示没有
          },
          "phone":{
              "phone":"18811755844",
              "phone_remarks":null //null表示没有
          }
        }
    }
  },
  '@ignore /api/reservation/hour_reservations': {
    "request_id":"RT1596705661741167",
    "error_code":0,
    "error_msg":"",
    "data":{
        "hour_reservations":[
            {
                "reservation_code":"5-1596684940860559",
                "check_in": "2020-08-09 00:00:00",
                "hour_reservation_start_time":"11:00:00",
                "hour_reservation_end_time":"12:00:00",
                "handmade_channel": 1,
                "client":{
                    "id":16,
                    "operator_id":10008,
                    "name":"222222",
                    "phone":"",
                    "formatted_phone":"",
                    "email":"",
                    "id_type":"",
                    "id_number":"",
                    "gender":0,
                    "birthday":null,
                    "country":null,
                    "delete_time":null,
                    "create_time":"2020-08-06 11:35:40",
                    "update_time":"2020-08-06 11:35:40",
                    "reservation_code":"5-1596684940860559"
                }
            },
            {
                "reservation_code":"5-1596684940860559",
                "check_in": "2020-08-09 00:00:00",
                "hour_reservation_start_time":"13:00:00",
                "hour_reservation_end_time":"14:00:00",
                "handmade_channel": 2,
                "client":{
                    "id":16,
                    "operator_id":10008,
                    "name":"222222",
                    "phone":"",
                    "formatted_phone":"",
                    "email":"",
                    "id_type":"",
                    "id_number":"",
                    "gender":0,
                    "birthday":null,
                    "country":null,
                    "delete_time":null,
                    "create_time":"2020-08-06 11:35:40",
                    "update_time":"2020-08-06 11:35:40",
                    "reservation_code":"5-1596684940860559"
                }
            },
            {
                "reservation_code":"5-1596684940860559",
                "check_in": "2020-08-09 00:00:00",
                "hour_reservation_start_time":"15:00:00",
                "hour_reservation_end_time":"16:00:00",
                "handmade_channel": 3,
                "client":{
                    "id":16,
                    "operator_id":10008,
                    "name":"222222",
                    "phone":"",
                    "formatted_phone":"",
                    "email":"",
                    "id_type":"",
                    "id_number":"",
                    "gender":0,
                    "birthday":null,
                    "country":null,
                    "delete_time":null,
                    "create_time":"2020-08-06 11:35:40",
                    "update_time":"2020-08-06 11:35:40",
                    "reservation_code":"5-1596684940860559"
                }
            },
            {
                "reservation_code":"5-1596684940860559",
                "check_in": "2020-08-09 00:00:00",
                "hour_reservation_start_time":"11:00:00",
                "hour_reservation_end_time":"20:00:00",
                "handmade_channel": 4,
                "client":{
                    "id":16,
                    "operator_id":10008,
                    "name":"222222",
                    "phone":"",
                    "formatted_phone":"",
                    "email":"",
                    "id_type":"",
                    "id_number":"",
                    "gender":0,
                    "birthday":null,
                    "country":null,
                    "delete_time":null,
                    "create_time":"2020-08-06 11:35:40",
                    "update_time":"2020-08-06 11:35:40",
                    "reservation_code":"5-1596684940860559"
                }
            },
        ],
        "checkout_reservation":{
          "code": "5-1596704750930618",
          "operator_id": 10008,
          status: "accepted",
          staying_status: "staying_checkout",
          check_in: "2020-08-09 00:00:00",
          check_out: "2020-08-08 00:00:00",
          house_id: 3613,
          thirdparty_type: 5,
          handmade_channel: 1,
          origin_house_id: "3613",
          booked_time: "2020-08-06 17:05:50",
          client: {
              id: 20,
              operator_id: 10008,
              name: "重复人",
              phone: "18811755844",
              formatted_phone: "",
              email: "",
              id_type: "",
              id_number: "",
              gender: 0,
              birthday: null,
              country: null,
              delete_time: null,
              create_time: "2020-08-06 17:05:50",
              update_time: "2020-08-06 17:05:50",
              reservation_code: "5-1596704750930618"
          },
         has_checked_out: false,
         out_status: "completed",
         checkin_time: {
              id: 171,
              reservation_code: "5-1596704750930618",
              check_in_time: "12:00",
              check_out_time: "10:30",
              create_time: "2020-08-11 13:47:54",
              update_time: "2020-08-11 13:48:02"
          }

        },
        "checkin_reservation":{
          "code": "5-1596704750930618",
          "operator_id": 10008,
          status: "accepted",
          staying_status: "staying_checkout",
          check_in: "2020-08-09 00:00:00",
          check_out: "2020-08-08 00:00:00",
          house_id: 3613,
          thirdparty_type: 5,
          handmade_channel: 1,
          origin_house_id: "3613",
          booked_time: "2020-08-06 17:05:50",
          client: {
              id: 20,
              operator_id: 10008,
              name: "重复人",
              phone: "18811755844",
              formatted_phone: "",
              email: "",
              id_type: "",
              id_number: "",
              gender: 0,
              birthday: null,
              country: null,
              delete_time: null,
              create_time: "2020-08-06 17:05:50",
              update_time: "2020-08-06 17:05:50",
              reservation_code: "5-1596704750930618"
          },
         has_checked_out: false,
         out_status: "completed",
         checkin_time: {
              id: 171,
              reservation_code: "5-1596704750930618",
              check_in_time: "21:10",
              check_out_time: "10:30",
              create_time: "2020-08-11 13:47:54",
              update_time: "2020-08-11 13:48:02"
          }

        }
    }
  },
  '@ignore /api/customer_service/chat/service_list':
  {
      "request_id":"RT1600154504915604",
      "error_code":0,
      "error_msg":"",
      "data":{
          "list":[
              {
                  "id":1, //转接时传此id
                  "operator_id":10008,
                  "status":1,//1=在线 0=掉线
                  "active":1,//是否启用
                  "is_super_server":false,
                  "avatar":"https://xg-storage.oss-cn-beijing.aliyuncs.com/VUM1583489446473.jpeg",
                  "name":"sadfasdf"
              },
              {
                  "id":1, //转接时传此id
                  "operator_id":10008,
                  "status":0,//1=在线 0=掉线
                  "active":1,//是否启用
                  "is_super_server":false,
                  "avatar":"https://xg-storage.oss-cn-beijing.aliyuncs.com/VUM1583489446473.jpeg",
                  "name":"sadfasdf"
              },
          ],
      }
  },
  '@ignore /api/chat/list': {
    "request_id": "RT1601179654856060",
    "error_code": 0,
    "error_msg": "",
    "data": {
        "list": [
            {
                "id": "0-941734798",
                "thirdparty_type": 0,
                "thirdparty_account_id": 177373,
                "origin_update_time": "2020-09-27 07:39:30",
                "last_message_time": "2020-09-27 07:39:30",
                "text_preview": "您需要先加下我微信",
                "create_time": "2020-09-27 07:37:38",
                "update_time": "2020-09-27 07:39:55",
                "unread_count": 0,
                "is_unfinished": 0,
                "is_top": 0,
                "house_info": {
                    "link_type": "house", //关联类型，可空。枚举:"house";"house_type";null
                    "link_id": 11166164, //关联id，可空。
                    "title": "2四期南洋海韵林居|85-4-401" //标题
                },
                "booking_info": {
                    "link_type": "reservation", //关联类型，可空。 枚举:"reservation";null
                    "link_id": "0-HMCSK3PAPB-5f6fd0c7aa733", //关联id，可空。
                    "status": "inquiring", //状态。 枚举:"inquiring"; "wait_stay"; "staying"; "completed"; "cancelled"
                    "title": "咨询 09-30~10-03" //标题
                },
                "host_info": {
                    "id": "0-257369004",
                    "thirdparty_type": "0",
                    "origin_customer_id": "257369004",
                    "name": "向海",
                    "photo": "https://z1.muscache.cn/im/pictures/user/ac8a2be9-6a73-41e2-9ebb-26337d66a50d.jpg?aki_policy=profile_x_medium",
                    "email": ""
                },
                "tenant_info": {
                    "id": "0-247329156",
                    "thirdparty_type": "0",
                    "origin_customer_id": "247329156",
                    "name": "喆",
                    "photo": "https://z1.muscache.cn/im/pictures/user/505abb30-0ee1-4eca-b207-5dae1fa6f098.jpg?aki_policy=profile_x_medium",
                    "email": "user-j3ejk5jkabclrq8b@guest.airbnb.com"
                }
            }
        ],
        "has_more": 1
    }
  },
  '@ignore /api/house_type/list': {
    "request_id": "RT1567592475358444",
    "error_code": 0,
    "error_msg": "",
    "data": {
        "list": [
            {
                "id": 1,
                "operator_id": 10004,
                "title": "house_type_1",
                "cover": null,
                "create_time": "2019-09-03 11:22:21",
                "update_time": "2019-09-03 11:22:21",
                "inventory": 0,
                "rest_inventory": 0,
                "thirdparty_types": [
                    2
                ],
                "house_type_prices": [
                    {
                        "id":248,
                        "house_type_id":91,
                        "thirdparty_account_id":101711,
                        "thirdparty_type":0,
                        "origin_house_id":"34870422",
                        "inventory":1,
                        "currency_type":"CNY",
                        "daily_price":679,
                        "cleaning_fee":35,
                        "cash_pledge":1,
                        "extra_tenant_price":35,
                        "weekend_price":124,
                        "sync_status":-2,
                        "is_shelf":1,
                        "create_time":"2019-10-18 12:40:01",
                        "update_time":"2019-10-18 12:40:35",
                        "extra_tenant_min_count":0,
                        "fail_message":"标题不满足20-50字要求,描述不符合80字以上要求,图片不符合至少7张要求,便利设施不符合至少5个要求,"
                    }
                ]
            },
            {
                "id": 2,
                "operator_id": 10004,
                "title": "house_type_1",
                "cover": null,
                "create_time": "2019-09-03 11:24:18",
                "update_time": "2019-09-03 11:24:18",
                "inventory": 1,
                "rest_inventory": 0,
                "thirdparty_types": [],
                "house_type_prices": []
            }
        ],
        "total": 2,
        "unbind_thirdparty_house_count": 0
    }
  },
  "@ignore /api/reservation_order/list":
  {
      "request_id":"RT1585044292976779",
      "error_code":0,
      "error_msg":"",
      "data":{
          "list":[
              {
                  "code":"5-1585035320872548", //预定单号
                  "operator_id":10008,
                  "thirdparty_type":5,//三方渠道
                  "origin_code":"1585035320872548",
                  "origin_house_id":"3330",
                  "origin_customer_id":"1585035320872548",
                  "thirdparty_customer_id":"5-1585035320872548",
                  "number_of_guests":0,
                  "booked_time":"2020-03-24 15:35:20",
                  "handmade_chanel":3,//渠道
                  "status":"accepted", //订单状态  可能的值为  wait_accept ,wait_pay,accepted,cancelled,denied,timeout
                  "remark":"",
                  "note":"",//订单备注
                  "create_time":"2020-03-24 15:35:20",
                  "update_time":"2020-03-24 15:35:20",
                  "thirdparty_username":"渠道账号", //微店、途供或者账号被删除后为空字符串
                   "currency_type":"CNY",   //币种
                   "creator":{//创建人
                      "reservation_order_code":"5-1585035320872548",
                      "name":"系统自动"
                  },
                  "settlement":{ //结算状态对象
                      "status":2, //0=结清 1=少结 2=多结
                      "more":12, //多结的钱
                      "less":0 //少结的钱
                  },
                  "house_fee":{ //房费对象
                      "amount":100, //房费
                      "currency_type":"CNY",
                      "reservation_order_code":"5-1585035320872548"
                  },
                  "commission":{ //佣金对象
                      "amount":100,
                      "currency_type":"CNY",
                      "reservation_order_code":"5-1585035320872548"
                  },
                  "net_house_fee":{ //净房费对象
                      "amount":0,
                      "currency_type":"CNY",
                      "reservation_order_code":"5-1585035320872548"
                  },
                  "other_income":{ //其他收入
                      "link_id":null,
                      "amount":0,
                      "currency_type":"-"
                  },
                  "expense":{ //支出
                      "link_id":null,
                      "amount":0,
                      "currency_type":"-"
                  },
                  "paid_house_fee":{//已支付的房费
                      "amount":12,
                      "currency_type":"CNY",
                      "link_id":"5-1585035320872548"
                  },
                  "thirdparty_customer":{ //下单人
                      "name":"wenpeng",
                      "phone":"",
                      "id":"5-1585035320872548"
                  },
                  "reservations":[
                      {
                          "code":"5-1585035320872548",//入住单号
                          "check_in":"2020-03-30 00:00:00", //check_in
                          "check_out":"2020-03-31 00:00:00",//check_out
                          "origin_house_id":"3330",
                          "thirdparty_type":5,
                          "house_id":3330,
                          "status":"accepted",
                          "number_of_guests":0,
                          "staying_status":"staying_wait",
                          "note":"",
                          "origin_reservation_id":"1585035320872548",
                          "thirdparty_customer_id":"5-1585035320872548",
                          "laravel_through_key":"5-1585035320872548",
                          "has_checked_out":false,
                          "tip_client_checked_in":false,//是否提示已登记
                          "tip_no_lock_password":false,//是否提示未设置门锁密码
                          "tip_no_auditing":false,//是否提示未审核
                          "out_status":"wait_stay",//订单状态
                          "reservation_tag":[//订单标签

                          ],
                          "conflict_label":{ //订单标记
                              "reservation_code":"5-1585035320872548",
                              "is_conflict":0  //0=否 1=是
                          },
                          "reservation_checkin_time":{ //入离时间对象，未设置时reservation_checkin_time对象为null
                              "check_in_time":12,
                              "check_out_time":''
                          },
                          "guest":{//入住人
                              "name":"wenpeng",
                              "phone":"",
                              "code":"5-1585035320872548",
                              "has_checked_out":false,
                              "out_status":null
                          },
                          "house_fee":{ //房费对象
                            "amount":100, //房费
                            "currency_type":"CNY",
                            "reservation_order_code":"5-1585035320872548"
                          },
                          "exceptions":[//为空表示此入住单正常
                              {
                                  "type":"arrange_room_failed", //异常类型，目前只有排房失败 arrange_room_failed
                                  "reservation_code":"5-1585035320872548",
                                  "title":"灰常公主Cinderella宁大工程服装学院边别墅套间",//title
                                  "house_type_id":null
                              }
                          ],
                          "house":{//订单所属房间，若house为null表示无法排房
                              "id":3330,
                              "house_id":3330,
                              "title":"000-大床套间CD你好世界你好差欧塞房产阿塞阀iOS大福企鹅窝髯口",
                               "cover_url":{//可能为null
                                  "original_url":"https://z0.muscache.cn/im/pictures/4786a703-f2b5-484d-9aa2-e4bbdb759625.jpg?aki_policy=x_large",
                                  "large_url":"https://z0.muscache.cn/im/pictures/4786a703-f2b5-484d-9aa2-e4bbdb759625.jpg?aki_policy=large",
                                  "extra_large_url":"https://z0.muscache.cn/im/pictures/4786a703-f2b5-484d-9aa2-e4bbdb759625.jpg?aki_policy=x_large",
                                  "extra_extra_large_url":"https://z0.muscache.cn/im/pictures/4786a703-f2b5-484d-9aa2-e4bbdb759625.jpg?aki_policy=x_large",
                                  "small_url":"https://z0.muscache.cn/im/pictures/4786a703-f2b5-484d-9aa2-e4bbdb759625.jpg?aki_policy=small"
                              },
                              "house_type":{//房间所属房型,房间未关联房型时house_type对象为null
                                  "id":95,
                                  "title":"000-大床套间【房型】",
                                  "house_type_id":95,
                                  "laravel_through_key":3330
                              }
                          }
                      }
                  ],
                  "client": {
                      "operator_id": 10008,
                      "name": "柯昌鑫",
                      "phone": "",
                      "id": 3563,
                      "update_time": "2020-12-15 20:16:25"
                  },
                  "comment": {//评论，可空，字段参考"评论详情"接口
                      "id": "1-922134861897",
                      "thirdparty_type": 1,
                      "status": 7,
                      "host_comment": {
                          "score": 5,
                          "content": "素质很高的客人，希望再次为您服务。",
                          "time": "2020-12-14 00:00:00"
                      },
                      "guest_comment": {
                          "score": 4.7,
                          "content": "非常好的入住体验，感谢热情招待。",
                          "photos": [
                              "https://pic.tujia.com/upload/comment/day_201215/thumb/202012151541589081_570_420.jpg"
                          ],
                          "time": "2020-12-14 00:00:00"
                      },
                      "host_reply": {
                          "content": "感谢信任，欢迎下次光临。感谢信任，欢迎下次光临。感谢信任，欢迎下次光临。感谢信任，欢迎下次光临。感谢信任，欢迎下次光临。感谢信任，欢迎下次光临。感谢信任，欢迎下次光临。感谢信任，欢迎下次光临。感谢信任，欢迎下次光临。",
                          "time": "2020-12-14 00:00:00"
                      },
                      "remain_days": 5
                  }
              },
              {
                  "code":"5-1585035320872548", //预定单号
                  "operator_id":10008,
                  "thirdparty_type":5,//三方渠道
                  "origin_code":"1585035320872548",
                  "origin_house_id":"3330",
                  "origin_customer_id":"1585035320872548",
                  "thirdparty_customer_id":"5-1585035320872548",
                  "number_of_guests":0,
                  "booked_time":"2020-03-24 15:35:20",
                  "handmade_chanel":3,//渠道
                  "status":"accepted", //订单状态  可能的值为  wait_accept ,wait_pay,accepted,cancelled,denied,timeout
                  "remark":"",
                  "note":"",//订单备注
                  "create_time":"2020-03-24 15:35:20",
                  "update_time":"2020-03-24 15:35:20",
                  "thirdparty_username":"渠道账号", //微店、途供或者账号被删除后为空字符串
                   "currency_type":"CNY",   //币种
                   "creator":{//创建人
                      "reservation_order_code":"5-1585035320872548",
                      "name":"系统自动"
                  },
                  "settlement":{ //结算状态对象
                      "status":2, //0=结清 1=少结 2=多结
                      "more":12, //多结的钱
                      "less":0 //少结的钱
                  },
                  "house_fee":{ //房费对象
                      "amount":100, //房费
                      "currency_type":"CNY",
                      "reservation_order_code":"5-1585035320872548"
                  },
                  "commission":{ //佣金对象
                      "amount":100,
                      "currency_type":"CNY",
                      "reservation_order_code":"5-1585035320872548"
                  },
                  "net_house_fee":{ //净房费对象
                      "amount":0,
                      "currency_type":"CNY",
                      "reservation_order_code":"5-1585035320872548"
                  },
                  "other_income":{ //其他收入
                      "link_id":null,
                      "amount":0,
                      "currency_type":"-"
                  },
                  "expense":{ //支出
                      "link_id":null,
                      "amount":0,
                      "currency_type":"-"
                  },
                  "paid_house_fee":{//已支付的房费
                      "amount":12,
                      "currency_type":"CNY",
                      "link_id":"5-1585035320872548"
                  },
                  "thirdparty_customer":{ //下单人
                      "name":"wenpeng",
                      "phone":"",
                      "id":"5-1585035320872548"
                  },
                  "reservations":[
                      {
                          "code":"5-1585035320872548",//入住单号
                          "check_in":"2020-03-30 00:00:00", //check_in
                          "check_out":"2020-03-31 00:00:00",//check_out
                          "origin_house_id":"3330",
                          "thirdparty_type":5,
                          "house_id":3330,
                          "status":"accepted",
                          "number_of_guests":0,
                          "staying_status":"staying_wait",
                          "note":"",
                          "origin_reservation_id":"1585035320872548",
                          "thirdparty_customer_id":"5-1585035320872548",
                          "laravel_through_key":"5-1585035320872548",
                          "has_checked_out":false,
                          "tip_client_checked_in":false,//是否提示已登记
                          "tip_no_lock_password":false,//是否提示未设置门锁密码
                          "tip_no_auditing":false,//是否提示未审核
                          "out_status":"wait_stay",//订单状态
                          "reservation_tag":[//订单标签

                          ],
                          "conflict_label":{ //订单标记
                              "reservation_code":"5-1585035320872548",
                              "is_conflict":0  //0=否 1=是
                          },
                          "reservation_checkin_time":{ //入离时间对象，未设置时reservation_checkin_time对象为null
                              "check_in_time":12,
                              "check_out_time":''
                          },
                          "guest":{//入住人
                              "name":"wenpeng",
                              "phone":"",
                              "code":"5-1585035320872548",
                              "has_checked_out":false,
                              "out_status":null
                          },
                          "house_fee":{ //房费对象
                            "amount":100, //房费
                            "currency_type":"CNY",
                            "reservation_order_code":"5-1585035320872548"
                          },
                          "exceptions":[//为空表示此入住单正常
                              {
                                  "type":"arrange_room_failed", //异常类型，目前只有排房失败 arrange_room_failed
                                  "reservation_code":"5-1585035320872548",
                                  "title":"灰常公主Cinderella宁大工程服装学院边别墅套间",//title
                                  "house_type_id":null
                              }
                          ],
                          "house":{//订单所属房间，若house为null表示无法排房
                              "id":3330,
                              "house_id":3330,
                              "title":"000-大床套间CD",
                               "cover_url":{//可能为null
                                  "original_url":"https://z0.muscache.cn/im/pictures/4786a703-f2b5-484d-9aa2-e4bbdb759625.jpg?aki_policy=x_large",
                                  "large_url":"https://z0.muscache.cn/im/pictures/4786a703-f2b5-484d-9aa2-e4bbdb759625.jpg?aki_policy=large",
                                  "extra_large_url":"https://z0.muscache.cn/im/pictures/4786a703-f2b5-484d-9aa2-e4bbdb759625.jpg?aki_policy=x_large",
                                  "extra_extra_large_url":"https://z0.muscache.cn/im/pictures/4786a703-f2b5-484d-9aa2-e4bbdb759625.jpg?aki_policy=x_large",
                                  "small_url":"https://z0.muscache.cn/im/pictures/4786a703-f2b5-484d-9aa2-e4bbdb759625.jpg?aki_policy=small"
                              },
                              "house_type":{//房间所属房型,房间未关联房型时house_type对象为null
                                  "id":95,
                                  "title":"000-大床套间【房型】",
                                  "house_type_id":95,
                                  "laravel_through_key":3330
                              }
                          }
                      }
                  ],
                  "client": {
                      "operator_id": 10008,
                      "name": "柯昌鑫",
                      "phone": "",
                      "id": 3563,
                      "update_time": "2020-12-15 20:16:25"
                  },
                  "comment": {//评论，可空，字段参考"评论详情"接口
                      "id": "1-922134861897",
                      "thirdparty_type": 1,
                      "status": 3,
                      "host_comment": {
                          "score": 5,
                          "content": "素质很高的客人，希望再次为您服务。",
                          "time": "2020-12-14 00:00:00"
                      },
                      "guest_comment": {
                          "score": 4.7,
                          "content": "非常好的入住体验，感谢热情招待。",
                          "photos": [
                              "https://pic.tujia.com/upload/comment/day_201215/thumb/202012151541589081_570_420.jpg"
                          ],
                          "time": "2020-12-14 00:00:00"
                      },
                      "host_reply": {
                          "content": "感谢信任，欢迎下次光临。",
                          "time": "2020-12-14 00:00:00"
                      },
                      "remain_days": 2
                  }
              },
              {
                  "code":"5-1585035320872548", //预定单号
                  "operator_id":10008,
                  "thirdparty_type":5,//三方渠道
                  "origin_code":"1585035320872548",
                  "origin_house_id":"3330",
                  "origin_customer_id":"1585035320872548",
                  "thirdparty_customer_id":"5-1585035320872548",
                  "number_of_guests":0,
                  "booked_time":"2020-03-24 15:35:20",
                  "handmade_chanel":3,//渠道
                  "status":"accepted", //订单状态  可能的值为  wait_accept ,wait_pay,accepted,cancelled,denied,timeout
                  "remark":"",
                  "note":"",//订单备注
                  "create_time":"2020-03-24 15:35:20",
                  "update_time":"2020-03-24 15:35:20",
                  "thirdparty_username":"渠道账号", //微店、途供或者账号被删除后为空字符串
                   "currency_type":"CNY",   //币种
                   "creator":{//创建人
                      "reservation_order_code":"5-1585035320872548",
                      "name":"系统自动"
                  },
                  "settlement":{ //结算状态对象
                      "status":2, //0=结清 1=少结 2=多结
                      "more":12, //多结的钱
                      "less":0 //少结的钱
                  },
                  "house_fee":{ //房费对象
                      "amount":100, //房费
                      "currency_type":"CNY",
                      "reservation_order_code":"5-1585035320872548"
                  },
                  "commission":{ //佣金对象
                      "amount":100,
                      "currency_type":"CNY",
                      "reservation_order_code":"5-1585035320872548"
                  },
                  "net_house_fee":{ //净房费对象
                      "amount":0,
                      "currency_type":"CNY",
                      "reservation_order_code":"5-1585035320872548"
                  },
                  "other_income":{ //其他收入
                      "link_id":null,
                      "amount":0,
                      "currency_type":"-"
                  },
                  "expense":{ //支出
                      "link_id":null,
                      "amount":0,
                      "currency_type":"-"
                  },
                  "paid_house_fee":{//已支付的房费
                      "amount":12,
                      "currency_type":"CNY",
                      "link_id":"5-1585035320872548"
                  },
                  "thirdparty_customer":{ //下单人
                      "name":"wenpeng",
                      "phone":"",
                      "id":"5-1585035320872548"
                  },
                  "reservations":[
                      {
                          "code":"5-1585035320872548",//入住单号
                          "check_in":"2020-03-30 00:00:00", //check_in
                          "check_out":"2020-03-31 00:00:00",//check_out
                          "origin_house_id":"3330",
                          "thirdparty_type":5,
                          "house_id":3330,
                          "status":"accepted",
                          "number_of_guests":0,
                          "staying_status":"staying_wait",
                          "note":"",
                          "origin_reservation_id":"1585035320872548",
                          "thirdparty_customer_id":"5-1585035320872548",
                          "laravel_through_key":"5-1585035320872548",
                          "has_checked_out":false,
                          "tip_client_checked_in":false,//是否提示已登记
                          "tip_no_lock_password":false,//是否提示未设置门锁密码
                          "tip_no_auditing":false,//是否提示未审核
                          "out_status":"wait_stay",//订单状态
                          "reservation_tag":[//订单标签

                          ],
                          "conflict_label":{ //订单标记
                              "reservation_code":"5-1585035320872548",
                              "is_conflict":0  //0=否 1=是
                          },
                          "reservation_checkin_time":{ //入离时间对象，未设置时reservation_checkin_time对象为null
                              "check_in_time":12,
                              "check_out_time":''
                          },
                          "guest":{//入住人
                              "name":"wenpeng",
                              "phone":"",
                              "code":"5-1585035320872548",
                              "has_checked_out":false,
                              "out_status":null
                          },
                          "house_fee":{ //房费对象
                            "amount":100, //房费
                            "currency_type":"CNY",
                            "reservation_order_code":"5-1585035320872548"
                          },
                          "exceptions":[//为空表示此入住单正常
                              {
                                  "type":"arrange_room_failed", //异常类型，目前只有排房失败 arrange_room_failed
                                  "reservation_code":"5-1585035320872548",
                                  "title":"灰常公主Cinderella宁大工程服装学院边别墅套间",//title
                                  "house_type_id":null
                              }
                          ],
                          "house":{//订单所属房间，若house为null表示无法排房
                              "id":3330,
                              "house_id":3330,
                              "title":"000-大床套间CD",
                               "cover_url":{//可能为null
                                  "original_url":"https://z0.muscache.cn/im/pictures/4786a703-f2b5-484d-9aa2-e4bbdb759625.jpg?aki_policy=x_large",
                                  "large_url":"https://z0.muscache.cn/im/pictures/4786a703-f2b5-484d-9aa2-e4bbdb759625.jpg?aki_policy=large",
                                  "extra_large_url":"https://z0.muscache.cn/im/pictures/4786a703-f2b5-484d-9aa2-e4bbdb759625.jpg?aki_policy=x_large",
                                  "extra_extra_large_url":"https://z0.muscache.cn/im/pictures/4786a703-f2b5-484d-9aa2-e4bbdb759625.jpg?aki_policy=x_large",
                                  "small_url":"https://z0.muscache.cn/im/pictures/4786a703-f2b5-484d-9aa2-e4bbdb759625.jpg?aki_policy=small"
                              },
                              "house_type":{//房间所属房型,房间未关联房型时house_type对象为null
                                  "id":95,
                                  "title":"000-大床套间【房型】",
                                  "house_type_id":95,
                                  "laravel_through_key":3330
                              }
                          }
                      }
                  ],
                  "client": {
                      "operator_id": 10008,
                      "name": "柯昌鑫",
                      "phone": "",
                      "id": 3563,
                      "update_time": "2020-12-15 20:16:25"
                  },
                  "comment": {//评论，可空，字段参考"评论详情"接口
                      "id": "1-922134861897",
                      "thirdparty_type": 1,
                      "status": 2,
                      "host_comment": {
                          "score": 5,
                          "content": "素质很高的客人，希望再次为您服务。",
                          "time": "2020-12-14 00:00:00"
                      },
                      "guest_comment": {
                          "score": 4.7,
                          "content": "非常好的入住体验，感谢热情招待。",
                          "photos": [
                              "https://pic.tujia.com/upload/comment/day_201215/thumb/202012151541589081_570_420.jpg"
                          ],
                          "time": "2020-12-14 00:00:00"
                      },
                      "host_reply": {
                          "content": "感谢信任，欢迎下次光临。",
                          "time": "2020-12-14 00:00:00"
                      },
                      "remain_days": 5
                  }
              },
              {
                  "code":"5-1585035320872548", //预定单号
                  "operator_id":10008,
                  "thirdparty_type":5,//三方渠道
                  "origin_code":"1585035320872548",
                  "origin_house_id":"3330",
                  "origin_customer_id":"1585035320872548",
                  "thirdparty_customer_id":"5-1585035320872548",
                  "number_of_guests":0,
                  "booked_time":"2020-03-24 15:35:20",
                  "handmade_chanel":3,//渠道
                  "status":"accepted", //订单状态  可能的值为  wait_accept ,wait_pay,accepted,cancelled,denied,timeout
                  "remark":"",
                  "note":"",//订单备注
                  "create_time":"2020-03-24 15:35:20",
                  "update_time":"2020-03-24 15:35:20",
                  "thirdparty_username":"渠道账号", //微店、途供或者账号被删除后为空字符串
                   "currency_type":"CNY",   //币种
                   "creator":{//创建人
                      "reservation_order_code":"5-1585035320872548",
                      "name":"系统自动"
                  },
                  "settlement":{ //结算状态对象
                      "status":2, //0=结清 1=少结 2=多结
                      "more":12, //多结的钱
                      "less":0 //少结的钱
                  },
                  "house_fee":{ //房费对象
                      "amount":100, //房费
                      "currency_type":"CNY",
                      "reservation_order_code":"5-1585035320872548"
                  },
                  "commission":{ //佣金对象
                      "amount":100,
                      "currency_type":"CNY",
                      "reservation_order_code":"5-1585035320872548"
                  },
                  "net_house_fee":{ //净房费对象
                      "amount":0,
                      "currency_type":"CNY",
                      "reservation_order_code":"5-1585035320872548"
                  },
                  "other_income":{ //其他收入
                      "link_id":null,
                      "amount":0,
                      "currency_type":"-"
                  },
                  "expense":{ //支出
                      "link_id":null,
                      "amount":0,
                      "currency_type":"-"
                  },
                  "paid_house_fee":{//已支付的房费
                      "amount":12,
                      "currency_type":"CNY",
                      "link_id":"5-1585035320872548"
                  },
                  "thirdparty_customer":{ //下单人
                      "name":"wenpeng",
                      "phone":"",
                      "id":"5-1585035320872548"
                  },
                  "reservations":[
                      {
                          "code":"5-1585035320872548",//入住单号
                          "check_in":"2020-03-30 00:00:00", //check_in
                          "check_out":"2020-03-31 00:00:00",//check_out
                          "origin_house_id":"3330",
                          "thirdparty_type":5,
                          "house_id":3330,
                          "status":"accepted",
                          "number_of_guests":0,
                          "staying_status":"staying_wait",
                          "note":"",
                          "origin_reservation_id":"1585035320872548",
                          "thirdparty_customer_id":"5-1585035320872548",
                          "laravel_through_key":"5-1585035320872548",
                          "has_checked_out":false,
                          "tip_client_checked_in":false,//是否提示已登记
                          "tip_no_lock_password":false,//是否提示未设置门锁密码
                          "tip_no_auditing":false,//是否提示未审核
                          "out_status":"wait_stay",//订单状态
                          "reservation_tag":[//订单标签

                          ],
                          "conflict_label":{ //订单标记
                              "reservation_code":"5-1585035320872548",
                              "is_conflict":0  //0=否 1=是
                          },
                          "reservation_checkin_time":{ //入离时间对象，未设置时reservation_checkin_time对象为null
                              "check_in_time":12,
                              "check_out_time":''
                          },
                          "guest":{//入住人
                              "name":"wenpeng",
                              "phone":"",
                              "code":"5-1585035320872548",
                              "has_checked_out":false,
                              "out_status":null
                          },
                          "house_fee":{ //房费对象
                            "amount":100, //房费
                            "currency_type":"CNY",
                            "reservation_order_code":"5-1585035320872548"
                          },
                          "exceptions":[//为空表示此入住单正常
                              {
                                  "type":"arrange_room_failed", //异常类型，目前只有排房失败 arrange_room_failed
                                  "reservation_code":"5-1585035320872548",
                                  "title":"灰常公主Cinderella宁大工程服装学院边别墅套间",//title
                                  "house_type_id":null
                              }
                          ],
                          "house":{//订单所属房间，若house为null表示无法排房
                              "id":3330,
                              "house_id":3330,
                              "title":"000-大床套间CD",
                               "cover_url":{//可能为null
                                  "original_url":"https://z0.muscache.cn/im/pictures/4786a703-f2b5-484d-9aa2-e4bbdb759625.jpg?aki_policy=x_large",
                                  "large_url":"https://z0.muscache.cn/im/pictures/4786a703-f2b5-484d-9aa2-e4bbdb759625.jpg?aki_policy=large",
                                  "extra_large_url":"https://z0.muscache.cn/im/pictures/4786a703-f2b5-484d-9aa2-e4bbdb759625.jpg?aki_policy=x_large",
                                  "extra_extra_large_url":"https://z0.muscache.cn/im/pictures/4786a703-f2b5-484d-9aa2-e4bbdb759625.jpg?aki_policy=x_large",
                                  "small_url":"https://z0.muscache.cn/im/pictures/4786a703-f2b5-484d-9aa2-e4bbdb759625.jpg?aki_policy=small"
                              },
                              "house_type":{//房间所属房型,房间未关联房型时house_type对象为null
                                  "id":95,
                                  "title":"000-大床套间【房型】",
                                  "house_type_id":95,
                                  "laravel_through_key":3330
                              }
                          }
                      }
                  ],
                  "client": {
                      "operator_id": 10008,
                      "name": "柯昌鑫",
                      "phone": "",
                      "id": 3563,
                      "update_time": "2020-12-15 20:16:25"
                  },
                  "comment": {//评论，可空，字段参考"评论详情"接口
                      "id": "1-922134861897",
                      "thirdparty_type": 1,
                      "status": 1,
                      "host_comment": {
                          "score": 5,
                          "content": "素质很高的客人，希望再次为您服务。",
                          "time": "2020-12-14 00:00:00"
                      },
                      "guest_comment": {
                          "score": 4.7,
                          "content": "非常好的入住体验，感谢热情招待。",
                          "photos": [
                              "https://pic.tujia.com/upload/comment/day_201215/thumb/202012151541589081_570_420.jpg"
                          ],
                          "time": "2020-12-14 00:00:00"
                      },
                      "host_reply": {
                          "content": "感谢信任，欢迎下次光临。",
                          "time": "2020-12-14 00:00:00"
                      },
                      "remain_days": 2
                  }
              },
              {
                  "code":"5-1585035320872548", //预定单号
                  "operator_id":10008,
                  "thirdparty_type":5,//三方渠道
                  "origin_code":"1585035320872548",
                  "origin_house_id":"3330",
                  "origin_customer_id":"1585035320872548",
                  "thirdparty_customer_id":"5-1585035320872548",
                  "number_of_guests":0,
                  "booked_time":"2020-03-24 15:35:20",
                  "handmade_chanel":3,//渠道
                  "status":"accepted", //订单状态  可能的值为  wait_accept ,wait_pay,accepted,cancelled,denied,timeout
                  "remark":"",
                  "note":"",//订单备注
                  "create_time":"2020-03-24 15:35:20",
                  "update_time":"2020-03-24 15:35:20",
                  "thirdparty_username":"渠道账号", //微店、途供或者账号被删除后为空字符串
                   "currency_type":"CNY",   //币种
                   "creator":{//创建人
                      "reservation_order_code":"5-1585035320872548",
                      "name":"系统自动"
                  },
                  "settlement":{ //结算状态对象
                      "status":2, //0=结清 1=少结 2=多结
                      "more":12, //多结的钱
                      "less":0 //少结的钱
                  },
                  "house_fee":{ //房费对象
                      "amount":100, //房费
                      "currency_type":"CNY",
                      "reservation_order_code":"5-1585035320872548"
                  },
                  "commission":{ //佣金对象
                      "amount":100,
                      "currency_type":"CNY",
                      "reservation_order_code":"5-1585035320872548"
                  },
                  "net_house_fee":{ //净房费对象
                      "amount":0,
                      "currency_type":"CNY",
                      "reservation_order_code":"5-1585035320872548"
                  },
                  "other_income":{ //其他收入
                      "link_id":null,
                      "amount":0,
                      "currency_type":"-"
                  },
                  "expense":{ //支出
                      "link_id":null,
                      "amount":0,
                      "currency_type":"-"
                  },
                  "paid_house_fee":{//已支付的房费
                      "amount":12,
                      "currency_type":"CNY",
                      "link_id":"5-1585035320872548"
                  },
                  "thirdparty_customer":{ //下单人
                      "name":"wenpeng",
                      "phone":"",
                      "id":"5-1585035320872548"
                  },
                  "reservations":[
                      {
                          "code":"5-1585035320872548",//入住单号
                          "check_in":"2020-03-30 00:00:00", //check_in
                          "check_out":"2020-03-31 00:00:00",//check_out
                          "origin_house_id":"3330",
                          "thirdparty_type":5,
                          "house_id":3330,
                          "status":"accepted",
                          "number_of_guests":0,
                          "staying_status":"staying_wait",
                          "note":"",
                          "origin_reservation_id":"1585035320872548",
                          "thirdparty_customer_id":"5-1585035320872548",
                          "laravel_through_key":"5-1585035320872548",
                          "has_checked_out":false,
                          "tip_client_checked_in":false,//是否提示已登记
                          "tip_no_lock_password":false,//是否提示未设置门锁密码
                          "tip_no_auditing":false,//是否提示未审核
                          "out_status":"wait_stay",//订单状态
                          "reservation_tag":[//订单标签

                          ],
                          "conflict_label":{ //订单标记
                              "reservation_code":"5-1585035320872548",
                              "is_conflict":0  //0=否 1=是
                          },
                          "reservation_checkin_time":{ //入离时间对象，未设置时reservation_checkin_time对象为null
                              "check_in_time":12,
                              "check_out_time":''
                          },
                          "guest":{//入住人
                              "name":"wenpeng",
                              "phone":"",
                              "code":"5-1585035320872548",
                              "has_checked_out":false,
                              "out_status":null
                          },
                          "house_fee":{ //房费对象
                            "amount":100, //房费
                            "currency_type":"CNY",
                            "reservation_order_code":"5-1585035320872548"
                          },
                          "exceptions":[//为空表示此入住单正常
                              {
                                  "type":"arrange_room_failed", //异常类型，目前只有排房失败 arrange_room_failed
                                  "reservation_code":"5-1585035320872548",
                                  "title":"灰常公主Cinderella宁大工程服装学院边别墅套间",//title
                                  "house_type_id":null
                              }
                          ],
                          "house":{//订单所属房间，若house为null表示无法排房
                              "id":3330,
                              "house_id":3330,
                              "title":"000-大床套间CD",
                               "cover_url":{//可能为null
                                  "original_url":"https://z0.muscache.cn/im/pictures/4786a703-f2b5-484d-9aa2-e4bbdb759625.jpg?aki_policy=x_large",
                                  "large_url":"https://z0.muscache.cn/im/pictures/4786a703-f2b5-484d-9aa2-e4bbdb759625.jpg?aki_policy=large",
                                  "extra_large_url":"https://z0.muscache.cn/im/pictures/4786a703-f2b5-484d-9aa2-e4bbdb759625.jpg?aki_policy=x_large",
                                  "extra_extra_large_url":"https://z0.muscache.cn/im/pictures/4786a703-f2b5-484d-9aa2-e4bbdb759625.jpg?aki_policy=x_large",
                                  "small_url":"https://z0.muscache.cn/im/pictures/4786a703-f2b5-484d-9aa2-e4bbdb759625.jpg?aki_policy=small"
                              },
                              "house_type":{//房间所属房型,房间未关联房型时house_type对象为null
                                  "id":95,
                                  "title":"000-大床套间【房型】",
                                  "house_type_id":95,
                                  "laravel_through_key":3330
                              }
                          }
                      }
                  ],
                  "client": {
                      "operator_id": 10008,
                      "name": "柯昌鑫",
                      "phone": "",
                      "id": 3563,
                      "update_time": "2020-12-15 20:16:25"
                  },
                  "comment": {//评论，可空，字段参考"评论详情"接口
                      "id": "1-922134861897",
                      "thirdparty_type": 1,
                      "status": 1,
                      "host_comment": {
                          "score": 5,
                          "content": "素质很高的客人，希望再次为您服务。",
                          "time": "2020-12-14 00:00:00"
                      },
                      "guest_comment": {
                          "score": 4.7,
                          "content": "非常好的入住体验，感谢热情招待。",
                          "photos": [
                              "https://pic.tujia.com/upload/comment/day_201215/thumb/202012151541589081_570_420.jpg"
                          ],
                          "time": "2020-12-14 00:00:00"
                      },
                      "host_reply": {
                          "content": "感谢信任，欢迎下次光临。",
                          "time": "2020-12-14 00:00:00"
                      },
                      "remain_days": 5
                  }
              },
              {
                  "code":"5-1585035320872548", //预定单号
                  "operator_id":10008,
                  "thirdparty_type":1,//三方渠道
                  "origin_code":"1585035320872548",
                  "origin_house_id":"3330",
                  "origin_customer_id":"1585035320872548",
                  "thirdparty_customer_id":"5-1585035320872548",
                  "number_of_guests":0,
                  "booked_time":"2020-03-24 15:35:20",
                  "handmade_chanel":3,//渠道
                  "status":"accepted", //订单状态  可能的值为  wait_accept ,wait_pay,accepted,cancelled,denied,timeout
                  "remark":"",
                  "note":"",//订单备注
                  "create_time":"2020-03-24 15:35:20",
                  "update_time":"2020-03-24 15:35:20",
                  "thirdparty_username":"渠道账号", //微店、途供或者账号被删除后为空字符串
                   "currency_type":"CNY",   //币种
                   "creator":{//创建人
                      "reservation_order_code":"5-1585035320872548",
                      "name":"系统自动"
                  },
                  "settlement":{ //结算状态对象
                      "status":2, //0=结清 1=少结 2=多结
                      "more":12, //多结的钱
                      "less":0 //少结的钱
                  },
                  "house_fee":{ //房费对象
                      "amount":100, //房费
                      "currency_type":"CNY",
                      "reservation_order_code":"5-1585035320872548"
                  },
                  "commission":{ //佣金对象
                      "amount":100,
                      "currency_type":"CNY",
                      "reservation_order_code":"5-1585035320872548"
                  },
                  "net_house_fee":{ //净房费对象
                      "amount":0,
                      "currency_type":"CNY",
                      "reservation_order_code":"5-1585035320872548"
                  },
                  "other_income":{ //其他收入
                      "link_id":null,
                      "amount":0,
                      "currency_type":"-"
                  },
                  "expense":{ //支出
                      "link_id":null,
                      "amount":0,
                      "currency_type":"-"
                  },
                  "paid_house_fee":{//已支付的房费
                      "amount":12,
                      "currency_type":"CNY",
                      "link_id":"5-1585035320872548"
                  },
                  "thirdparty_customer":{ //下单人
                      "name":"wenpeng",
                      "phone":"",
                      "id":"5-1585035320872548"
                  },
                  "reservations":[
                      {
                          "code":"5-1585035320872548",//入住单号
                          "check_in":"2020-03-30 00:00:00", //check_in
                          "check_out":"2020-03-31 00:00:00",//check_out
                          "origin_house_id":"3330",
                          "thirdparty_type":0,
                          "house_id":3330,
                          "status":"accepted",
                          "number_of_guests":0,
                          "staying_status":"staying_wait",
                          "note":"",
                          "origin_reservation_id":"1585035320872548",
                          "thirdparty_customer_id":"5-1585035320872548",
                          "laravel_through_key":"5-1585035320872548",
                          "has_checked_out":false,
                          "tip_client_checked_in":false,//是否提示已登记
                          "tip_no_lock_password":false,//是否提示未设置门锁密码
                          "tip_no_auditing":false,//是否提示未审核
                          "out_status":"wait_stay",//订单状态
                          "reservation_tag":[//订单标签

                          ],
                          "conflict_label":{ //订单标记
                              "reservation_code":"5-1585035320872548",
                              "is_conflict":0  //0=否 1=是
                          },
                          "reservation_checkin_time":{ //入离时间对象，未设置时reservation_checkin_time对象为null
                              "check_in_time":12,
                              "check_out_time":''
                          },
                          "guest":{//入住人
                              "name":"wenpeng",
                              "phone":"",
                              "code":"5-1585035320872548",
                              "has_checked_out":false,
                              "out_status":null
                          },
                          "house_fee":{ //房费对象
                            "amount":100, //房费
                            "currency_type":"CNY",
                            "reservation_order_code":"5-1585035320872548"
                          },
                          "exceptions":[//为空表示此入住单正常
                              {
                                  "type":"arrange_room_failed", //异常类型，目前只有排房失败 arrange_room_failed
                                  "reservation_code":"5-1585035320872548",
                                  "title":"灰常公主Cinderella宁大工程服装学院边别墅套间",//title
                                  "house_type_id":null
                              }
                          ],
                          "house":{//订单所属房间，若house为null表示无法排房
                              "id":3330,
                              "house_id":3330,
                              "title":"000-大床套间CD",
                               "cover_url":{//可能为null
                                  "original_url":"https://z0.muscache.cn/im/pictures/4786a703-f2b5-484d-9aa2-e4bbdb759625.jpg?aki_policy=x_large",
                                  "large_url":"https://z0.muscache.cn/im/pictures/4786a703-f2b5-484d-9aa2-e4bbdb759625.jpg?aki_policy=large",
                                  "extra_large_url":"https://z0.muscache.cn/im/pictures/4786a703-f2b5-484d-9aa2-e4bbdb759625.jpg?aki_policy=x_large",
                                  "extra_extra_large_url":"https://z0.muscache.cn/im/pictures/4786a703-f2b5-484d-9aa2-e4bbdb759625.jpg?aki_policy=x_large",
                                  "small_url":"https://z0.muscache.cn/im/pictures/4786a703-f2b5-484d-9aa2-e4bbdb759625.jpg?aki_policy=small"
                              },
                              "house_type":{//房间所属房型,房间未关联房型时house_type对象为null
                                  "id":95,
                                  "title":"000-大床套间【房型】",
                                  "house_type_id":95,
                                  "laravel_through_key":3330
                              }
                          }
                      }
                  ],
                  "client": {
                      "operator_id": 10008,
                      "name": "柯昌鑫",
                      "phone": "",
                      "id": 3563,
                      "update_time": "2020-12-15 20:16:25"
                  },
                  "comment": {//评论，可空，字段参考"评论详情"接口
                      "id": "1-922134861897",
                      "thirdparty_type": 1,
                      "status": 0,
                      "host_comment": {
                          "score": 5,
                          "content": "素质很高的客人，希望再次为您服务。",
                          "time": "2020-12-14 00:00:00"
                      },
                      "guest_comment": {
                          "score": 4.7,
                          "content": "非常好的入住体验，感谢热情招待。",
                          "photos": [
                              "https://pic.tujia.com/upload/comment/day_201215/thumb/202012151541589081_570_420.jpg"
                          ],
                          "time": "2020-12-14 00:00:00"
                      },
                      "host_reply": {
                          "content": "感谢信任，欢迎下次光临。",
                          "time": "2020-12-14 00:00:00"
                      },
                      "remain_days": 0
                  }
              },
          ],
          "count":10
      }
  },
  "@ignore /api/reservation_comment/detail": RateDetail,
  "@ignore /api/schedule/staff_client/tasks": TaskList
};
